import { Button, Flex } from "@chakra-ui/react";
import React, { PropsWithChildren, ReactNode } from "react";
import { Link } from "react-router";

import { UploadTask } from "@nens/brostar/openapi-client";

import { BroErrorModal } from "@/components/bro-error-modal";

import { BottomBarWrapper } from "./bottom-bar-wrapper";

type FormButtons = {
  resetButton: ReactNode;
  submitButton: ReactNode;
  cancelButton: ReactNode;
  uploadErrorButton: ReactNode;
  submitButtonCustomTitle: (title: string) => ReactNode;
};

export type RenderFormButtons = (buttons: FormButtons) => ReactNode;

interface Props {
  uploadTask?: UploadTask;
  isValid?: boolean;
  formId: string;
  onReset: () => void;
  renderButtons?: RenderFormButtons;
}

export const SubmitAndCancel: React.FC<PropsWithChildren<Props>> = ({
  uploadTask,
  isValid,
  formId,
  onReset,
  renderButtons,
}) => {
  const formButtons: FormButtons = {
    resetButton: (
      <Button type="reset" title="Reset het formulier." variant="outlineGrey" onClick={onReset}>
        Reset
      </Button>
    ),
    cancelButton: (
      <Link to="/">
        <Button variant="outlineGrey" type="button">
          Annuleren
        </Button>
      </Link>
    ),
    submitButton: (
      <Button variant={isValid ? "primary" : "outlinePrimary"} type="submit" form={formId}>
        Verzenden
      </Button>
    ),
    submitButtonCustomTitle: (title: string) => (
      <Button variant={isValid ? "primary" : "outlinePrimary"} type="submit" form={formId}>
        {title}
      </Button>
    ),
    uploadErrorButton: uploadTask && (
      <BroErrorModal variant="outlineGrey" uploadTask={uploadTask} />
    ),
  };

  if (renderButtons)
    return (
      <Flex pt={4} w="full">
        {renderButtons(formButtons)}
      </Flex>
    );

  const { resetButton, cancelButton, submitButton, uploadErrorButton } = formButtons;

  return (
    <BottomBarWrapper>
      {uploadErrorButton}
      {resetButton}
      {cancelButton}
      {submitButton}
    </BottomBarWrapper>
  );
};
